import TickIcon from "Assets/Img/TickIcon";
import Button from "../../../../Components/Common/Button/Button";
import SectionCard from "./SectionCard";

interface SuccessStepProps {
  onBackToProjects: () => void;
  drawNo: string;
  totalAmount: string;
  bankName: string;
}

const SuccessStep = ({
  onBackToProjects,
  drawNo,
  totalAmount,
  bankName,
}: SuccessStepProps) => {
  const adminName =
    JSON.parse(localStorage.getItem("user") ?? "")?.companyName || "Admin";
  const nextSteps: string[] = [
    `${adminName} schedules and performs field inspection`,
    "Remaining lien waivers collected from outstanding subcontractors",
    `CSC prepares and submits construction progress report to ${bankName || "the bank"}`,
    "Bank reviews and approves draw disbursement",
  ];
  return (
    <section className="screen activeScreen" aria-labelledby="success-title">
      <SectionCard className="successCard">
        <div className="successWrap">
          <div className="successIcon" aria-hidden="true">
            <TickIcon />
          </div>
          <h2 className="successTitle" id="success-title">
            Draw Request Submitted
          </h2>
          <p className="successSub">
            Draw #{drawNo} for {totalAmount} has been submitted. {adminName} has
            been notified and will schedule a field inspection.
          </p>

          <div className="nextSteps">
            <p className="nextStepsTitle">What happens next</p>
            {nextSteps.map((step, index) => (
              <p className="nextStep" key={step}>
                <span className="stepArrow">{index + 1}</span>
                {step}
              </p>
            ))}
          </div>

          <Button className="btn btnPrimary" onClick={onBackToProjects}>
            ← Back to Projects
          </Button>
        </div>
      </SectionCard>
    </section>
  );
};

export default SuccessStep;
